import { TableModalidade } from "./Components/table/TableModalidade";

export const PageModalidades = () => {
  return <TableModalidade />;
};
